import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import Typography from "@material-ui/core/Typography";

export default class SponsorLinkDialog extends React.Component {
  state = {
    link: ""
  };

  UNSAFE_componentWillMount = () => {
    let sponsorLinks =
      this.props.tournament[
        "sponsorLinks" +
          (this.props.sponsorGroup !== undefined
            ? this.props.sponsorGroup.toString()
            : "")
      ] || [];
    if (sponsorLinks[this.props.sponsorIndex]) {
      this.setState({ link: sponsorLinks[this.props.sponsorIndex] });
    }
  };

  handleChange = event => {
    this.setState({ link: event.target.value });
  };

  handleSubmit = e => {
    e.preventDefault();
    let sponsors =
      this.props.tournament[
        "sponsors" +
          (this.props.sponsorGroup !== undefined
            ? this.props.sponsorGroup.toString()
            : "")
      ] || [];
    let sponsorLinks =
      this.props.tournament[
        "sponsorLinks" +
          (this.props.sponsorGroup !== undefined
            ? this.props.sponsorGroup.toString()
            : "")
      ] || [];
    let newLinks = [];
    sponsors.forEach((s, i) => {
      newLinks.push(sponsorLinks[i] || "");
    });
    newLinks[this.props.sponsorIndex] = this.state.link;
    let toUpdate = {};
    toUpdate[
      "sponsorLinks" +
        (this.props.sponsorGroup !== undefined
          ? this.props.sponsorGroup.toString()
          : "")
    ] = newLinks;
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
    this.props.toggleDialog();
  };

  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {languages.present.sponsorsLink}
        </DialogTitle>
        <form>
          <DialogContent style={{ width: 400, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText />
            <TextField
              autoFocus
              fullWidth
              name="link"
              value={this.state.link}
              onChange={this.handleChange}
            />
          </DialogContent>
          {this.props.errorMessage && (
            <DialogActions>
              <div>
                <Typography style={{ color: "red" }}>
                  {this.props.errorMessage}
                </Typography>
              </div>
            </DialogActions>
          )}
          <DialogActions>
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={this.handleSubmit}
              variant="contained"
              color="primary"
              type="submit"
            >
              {languages.general.save}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
